export default function Tips(props:{onBack:()=>void}) {
  return <div className="ModalContainer Tips"><div>
    <p>Once a page has been completed, you can use the LEFT and RIGHT ARROW keys to rapidly jump back and forth between all completed pages.  This is the most effective way to scroll from the end of the document back to the beginning if you want to make any changes to your answers.</p>
    <div className="BackContainer">
      <button className="button" onClick={props.onBack}>Back</button>
    </div>
  </div></div>
}